export default function demoOrder({ stores }: CommandArgs) {
  const orderStore = stores['order'] as OrderStore

  async function amendOrderWithCustomQuestions(): Promise<Order | undefined> {
    return orderStore.order ?? undefined
  }

  return { amendOrderWithCustomQuestions }
}
